import React from 'react';
import { Row } from '@fiverr-private/briefs_table';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { BriefStatusTag } from '@fiverr-private/dynamic_matching';
import { getContext } from '@fiverr-private/fiverr_context';
import { Box } from '@fiverr-private/theme';
import { BriefItem } from '../../../../../lib/types/brief';
import { getCreatedByUserName } from '../../../../../lib/utils/getters';
import { formatTimestamp } from '../../../../../lib/utils/time';

interface MobileProps {
  row: Row<BriefItem>;
}

export const Middle: React.FC<MobileProps> = ({ row }: MobileProps) => {
  const { organizationId } = getContext();
  return (
    <Stack direction="column" gap="8">
      <Stack direction="column" gap="2">
        <Typography color="grey_1200" as="h6" size="h_xxs">
          {row.original.title}
        </Typography>

        <Stack direction="row" alignItems="center">
          <Typography as="p" color="grey_900" size="b_sm">
            {formatTimestamp(row.original.createdAt)}
          </Typography>
          {!!organizationId && (
            <>
              <Box width="3px" height="3px" borderRadius="circle" backgroundColor="grey_900" />
              <Typography as="p" size="b_sm" color="grey_900">
                {getCreatedByUserName(row.original.createdBy)}
              </Typography>
            </>
          )}
        </Stack>
        <BriefStatusTag status={row.original.briefDisplayStatus} />
      </Stack>
    </Stack>
  );
};
